import { RootState } from "../../store";
import { ExecutionLogState } from "../../../components/pages/execution-log/utils/types/types";

export const executionLogStateSelector = (
  state: RootState,
): ExecutionLogState => state.executionLog;
